import React from 'react';
import {useMediaQuery} from '@mui/material';
import AboutDesktop from './AboutDesktop';
import AboutMobile from './AboutMobile';

const About = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <div>
      {isDesktop && (
        <AboutDesktop></AboutDesktop>
      )}
      {isMobile && (
        <AboutMobile></AboutMobile>
      )}
    </div>
        
  );
};

export default About;
